<template>
  <!-- <div class="header"> -->
    <div class="">
      <div class="col-xs-8 col-sm-10 col-md-6">
        <div class="logo-wrap">
          <router-link to="/pages/Index">
            <img class="logoImg" src="../assets/logo.png" style="width:60px;height:60px;"/>
            <p style="margin-left:5px;">微心帮</p>
          </router-link>
        </div>
      </div>
      <div class="col-xs-2 col-sm-2  col-md-6">
          <el-menu
            :default-active="activeIndex2"
            class="el-menu-demo visible-lg-block visible-md-block"
            mode="horizontal"
            text-color="#000"
            active-text-color="#ff711f">
            <el-menu-item index="Index"><router-link to="/pages/Index">首页</router-link></el-menu-item>
            <el-menu-item index="About"><router-link to="/pages/About">关于我们</router-link></el-menu-item>
            <el-menu-item index="Join"><router-link to="/pages/Join">加入我们</router-link></el-menu-item>
            <el-menu-item index="Hotel"><a href="https://admin.weixinbang.com.cn/#/login" target="_blank">商户登录</a></el-menu-item>
             <!--<el-submenu index="5">
             <template slot="title">商户登录</template>
             <el-menu-item index="5-1">选项1</el-menu-item>
             <el-menu-item index="5-2">选项2</el-menu-item>
             <el-menu-item index="5-3">选项3</el-menu-item>
           </el-submenu>-->
          </el-menu>
          <div class="drawer visible-xs-block visible-sm-block ">
            <el-dropdown style="margin-left:20px;">
              <el-button type="primary">
                <i class="el-icon-menu"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item><router-link to="/pages/Index">首页</router-link></el-dropdown-item>
                <el-dropdown-item><router-link to="/pages/About">关于我们</router-link></el-dropdown-item>
                <el-dropdown-item><router-link to="/pages/Join">加入我们</router-link></el-dropdown-item>
                <el-dropdown-item><a href="https://admin.weixinbang.com.cn/#/login" target="_blank" class="dropdown-a">商户登录</a></el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
      </div>
    </div>
    <!-- <el-row class="header-row" :gutter="20">
      <el-col class="headder-col logo" :span="12">

      </el-col>
      <el-col class="headder-col head-text" :span="12"> -->
      <!-- </el-col>
    </el-row> -->
  <!-- </div> -->
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    export default {
        name: "indexHeader",
        data() {
          return {
              activeIndex2: '',
              visible: false,
              drawer: false,
              direction: 'rtl'
          };
        },
        computed: {
          ...mapGetters([
            'getSubmenu'
          ])
        },
        watch: {
          getSubmenu(n, o) {
            this.activeIndex2 = n
          }
        },
        methods: {

          handleSelect(key, keyPath) {
          },
          showDrawer () {
            this.drawer = true
          },
          handleClose () {
            this.drawer = false
          }
        },
      created() {
        this.activeIndex2 = this.getSubmenu
        if (document.body.clientWidth < 1300) {
          this.visible = true
        }
      }
    }
</script>

<style lang="scss" scoped>
  /*@import 'element-ui/lib/theme-chalk/display.css';*/
  @import '../assets/scss/index.scss';
  *{
    padding: 0;
    margin: 0;
  }
  a{
    // color:#ff711f;
    text-decoration:none;
    color: #606266;
  }
  a:hover{
    text-decoration:none;
    color: #ff711f;
  }
  .header{
    width: 100%;
    height: 60px;
    border-bottom: 1px solid #eee;
    position: fixed;
    top:0;
    // z-index: 100;
    background: #fff;
  }
  .el-col {
    border-radius: 4px;
  }
  .header-row{
    display: inline-block;
    width: 100%;
    margin: 0 auto;
  }
  .logo {
    display: flex;
    /*flex: 1;*/
    float: left;
  }
  .headder-col {
    border-radius: 4px;
    min-height: 36px;
    height: 60px;
  }
  .logo .logoImg{
    width: 30px;
    height: 30px;
  }
  .head-text {
    display: flex;
    /*flex: 8;*/
    float: right;
  }
  .el-menu-demo{
    display: flex;
    justify-content: flex-end;
  }
  .el-menu-demo>.el-menu-item,.el-submenu{
    list-style-type: none;
    display: inline;
    margin: 0 10px;
    padding-bottom: 6px;
  }
  .el-menu-item{
    /* color: #333!important; */
    list-style-type: none;
    margin: 10px 0;
    border-bottom: 1px solid #333;
    padding: 0;
  }
  .el-menu-item a{
    /* color: #333333; */
    text-decoration: none;
    padding: 20px;
    /*height: 60px;
    line-height: 60px;*/
  }
  .el-submenu__title{
    display: inline-block;
    /* color: #333!important; */
  }
  .logo-wrap{
    width: 100px;
    height: 60px;
    line-height: 60px;
    position: relative;
    @include flex(center);
    p{
      width: 100px;
      display: block;
      position: absolute;
      top: 0px;
      left: 70px;
      height: 60px;
      // line-height: 75px;/
      font-weight: 600;
      font-size: 28px;
      // @include px2rem(font-size, 36);
      color: #ff711f;
    }
  }
  .el-icon-s-operation{
    // float: right;
    @include px2rem(width, 30);
    @include px2rem(height, 30);
    @include px2rem(font-size, 30);
    color: #fff;
  }
  .drawer{
    width: 100%;
    display: flex;
    height: 60px;
    line-height: 60px;
    justify-content: flex-end;
    justify-items: center;
    align-items: center;
  }
  .glyphicon{
    text-align: center;
    line-height: 40px;
  }
  .el-button--primary{
    // @include px2rem(width, 50);
    // @include px2rem(height, 50);
    margin-top: 5px;
    width: 40px !important;
    height: 40px !important;
    background-color: #fff !important;
    border-color: #fff !important;
  }
  .el-dropdown-menu{
    width: 100px;
    text-align: center;
    color:#ff711f;
  }
  .el-dropdown-menu__item:hover{
    color:#ff711f;
  }
  .dropdown-a{

  }
  .dropdown-a:hover{
    color:#ff711f;
  }
  .el-button--primary:hover{
    background: #fff;
    border-color: #fff;
  }
  .el-icon-menu{
    font-size: 24px;
    color:#ff711f;
  }
</style>



// WEBPACK FOOTER //
// src/components/IndexHeader.vue